import { UPDATE_EXT_TAG_ATTRIBUTE } from './constants';

/**
 * UPDATE_EXT_TAG_ATTRIBUTE action definition
 *
 * @param  String extTagAttribute info from page preload
 * @return {Object} UPDATE_EXT_TAG_ATTRIBUTE action definition
 */
export function updateExtTagAttribute(extTagAttribute) {
  return {
    type: UPDATE_EXT_TAG_ATTRIBUTE,
    extTagAttribute,
  };
}
